import { Directive, Input, OnDestroy } from "@angular/core";
import { AbstractControl, UntypedFormGroup } from "@angular/forms";
import moment from "moment";
import { IKeyValue } from "../../models/dtos";
import { TplFilterContext } from "./tpl-filter-context";
import { IMinMaxDate, ITplFilter } from "./tpl-filter.models";

@Directive()

export abstract class FilterBaseComponent implements ITplFilter, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() filterContext: TplFilterContext;

    control: AbstractControl;
    open = false;
    filterLength: number;

    constructor(readonly name: string) {
    }

    ngOnDestroy(): void {
        this.filterContext.deregister(this.name, this);

        if (!this.control) {
            return;
        }

        this.form.removeControl(this.name);
    }

    abstract isActive(): boolean;

    abstract value(): any;

    flush() {
        this.filterContext.filterState[this.name] = this.value();
    }

    init(state: any) {
        const mystate = state[this.name];

        this.onFilterInit(mystate ?? null);
    }

    prepare(): void {
        // Måste finnas pga basklass
    }

    keyValueSearchFn = (val: string, item: IKeyValue) => item.value?.toUpperCase().includes(val?.toUpperCase()) ?? false;

    protected abstract onAddFilterToContext(filterContext: TplFilterContext);

    protected onFormInit(control: AbstractControl): void {
        this.onAddFilterToContext(this.filterContext);

        this.control = control;

        this.form.removeControl(this.name);
        this.form.addControl(this.name, this.control);
        this.control.setParent(this.form);

        this.control.valueChanges.subscribe(v => this.onFormChange(v));

        this.init(this.filterContext?.filterState);

        this.open = this.isActive();
    }

    protected abstract onFilterInit(state: any): void;

    protected onFormChange(value: any): void {
        // Måste finnas pga basklass
    }

    protected isBetween(actual: number, min: number, max: number): boolean {
        if (actual === null || actual === undefined) {
            return false;
        }

        return (!min || min <= actual) && (!max || max >= actual);
    }

    protected isDateBetween(dateTocheck: Date, interval: IMinMaxDate): boolean {
        if(!dateTocheck) {
            return false;
        }

        const checkTime = moment(dateTocheck).toDate().getTime();
        return interval.min.getTime() <= checkTime && interval.max.getTime() >= checkTime;
    }
}
